export const backgroundColour = {
  buyer: '#d1ecf1',
  seller: '#f8d7da',
};
